import { sendGAEvent } from "./utils/googleAnalytics";

export const profileLoaded = () => {
  sendGAEvent("Profile", "profileLoaded");
};

export const reportSuspicious = () => {
  sendGAEvent("Profile.recentActivity", "reportSuspicious");
};
